import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'companyExecutives/FETCH_REQUEST';
const FETCH_SUCCESS = 'companyExecutives/FETCH_SUCCESS';
const FETCH_COMPANY_SUCCESS = 'companyExecutives/FETCH_COMPANY_SUCCESS';
const FETCH_FAILURE = 'companyExecutives/FETCH_FAILURE';

const initialState = {
  companies: [],
  loadedCompanies: [],
  loadedIds: [],
  total_size: 0,
  loaded: false,
  loading: false,
  errors: []
};

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchCompanySuccess(payload) {
  return {
    type: FETCH_COMPANY_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadCompany(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const loadedIds = state.companies.loadedIds ? state.companies.loadedIds.slice() : [];
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }));

    return api(`api/v1/companies/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchCompanySuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      });
  }
}

export function loadCompanies(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api('api/v1/companies', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      });
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        total_size: payload.total_size,
        companies: [...payload.result]
      });
    case FETCH_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedCompanies: [
          ...state.loadedCompanies,
          payload
        ]
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      });
    default:
      return state
  }
}

